// extracted by mini-css-extract-plugin
export default {"wrapper":"RenameField_wrapper__yZqu7","options":"RenameField_options__2ZGlr","option":"RenameField_option__tzOvj","option-active":"RenameField_option-active__hlNjo"};